import React from 'react';
import { IProps } from './type';

const PackageIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '24'}
      height={height ? height : '24'}
      viewBox={viewBox ? viewBox : '0 0 24 24'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 21V13M12.75 21L5.69 16.5875C5.23048 16.3003 5.00072 16.1567 4.87536 15.9305C4.75 15.7043 4.75 15.4334 4.75 14.8915V8M12.75 21L16.75 18.5L19.81 16.5875C20.2695 16.3003 20.4993 16.1567 20.6246 15.9305C20.75 15.7043 20.75 15.4334 20.75 14.8915V8M12.75 13L4.75 8M12.75 13L20.75 8M4.75 8L11.69 3.6625C12.2055 3.34033 12.4632 3.17925 12.75 3.17925C13.0368 3.17925 13.2945 3.34033 13.81 3.6625L20.75 8"
        stroke={strokeColor ? strokeColor : "#666666"}
        strokeLinejoin="round" />
      <path
        d="M16.25 14.5C16.25 14.7761 16.4739 15 16.75 15C17.0261 15 17.25 14.7761 17.25 14.5H16.25ZM16.6246 10.5695L17.062 10.3271L16.6246 10.5695ZM8.485 5.924L15.545 10.3365L16.075 9.4885L9.015 5.076L8.485 5.924ZM17.25 14.5V11.6085H16.25V14.5H17.25ZM15.545 10.3365C15.7827 10.4851 15.9312 10.5785 16.0384 10.6607C16.1372 10.7364 16.1695 10.7797 16.1873 10.8119L17.062 10.3271C16.9545 10.1331 16.8092 9.99148 16.6468 9.86705C16.4929 9.74909 16.2968 9.62712 16.075 9.4885L15.545 10.3365ZM17.25 11.6085C17.25 11.347 17.2505 11.116 17.2321 10.923C17.2126 10.7194 17.1695 10.5211 17.062 10.3271L16.1873 10.8119C16.2052 10.8441 16.2247 10.8943 16.2366 11.0182C16.2495 11.1527 16.25 11.3281 16.25 11.6085H17.25Z"
        fill={fillColor ? fillColor : "#666666"} />
    </svg>

  )
};

export default PackageIcon;
